/**
 * Who you are actually hiring.
 *
 * A studio of this size has one real objection to answer — "is there anybody
 * behind this?" — so the section says the size out loud rather than dressing it
 * up as a team page with stock photographs. The three "no" points are the
 * agency failures this structure exists to avoid, named directly.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import styles from './Studio.module.css';

export function Studio() {
  const { t } = useI18n();

  return (
    <Section id="studio" title={t.studio.title} lead={t.studio.lead}>
      <div className={styles.layout}>
        <div className={styles.main}>
          <p className={styles.body}>{t.studio.body}</p>

          <div className={`grid ${styles.points}`}>
            {t.studio.points.map((point) => (
              <article key={point.title} className="cell">
                <h3 className={styles.pointTitle}>{point.title}</h3>
                <p className={styles.pointBody}>{point.body}</p>
              </article>
            ))}
          </div>
        </div>

        <dl className={styles.facts}>
          {t.studio.facts.map((fact) => (
            <div key={fact.label} className={styles.fact}>
              <dt className={styles.factLabel}>{fact.label}</dt>
              <dd className={styles.factValue}>{fact.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </Section>
  );
}
